$(document).ready(function () {

  console.log("Cache buster V4");

  // Custom: remove unhelpful aria-label from third-party loyalty button
  setTimeout(function () {
    var loyaltyBtn = document.getElementById('bon-loyalty-btn');
    if (loyaltyBtn) {
      loyaltyBtn.removeAttribute('aria-label');
    }
  }, 3000);

  // Custom: disable aria-live on Swiper wrappers to prevent excessive announcements
  document.querySelectorAll('.swiper-wrapper').forEach(function (wrapper) {
    wrapper.setAttribute('aria-live', 'off');
  });

  // Custom: video-banner play/pause control
  document.querySelectorAll('.video-banner').forEach(function (banner) {
    var btn = banner.querySelector('.video-banner-control');
    var video = banner.querySelector('video');
    var label = btn && btn.querySelector('.video-banner-control__label');
    if (!btn || !video || !label) return;

    btn.addEventListener('click', function () {
      var isPlaying = btn.classList.contains('video-banner-control--playing');
      if (isPlaying) {
        video.pause();
        btn.classList.replace('video-banner-control--playing', 'video-banner-control--paused');
        btn.setAttribute('aria-pressed', 'true');
        label.textContent = 'Play Video';
      } else {
        video.play();
        btn.classList.replace('video-banner-control--paused', 'video-banner-control--playing');
        btn.setAttribute('aria-pressed', 'false');
        label.textContent = 'Pause Video';
      }
    });
  });

  // Share buttons disclosure
  function initShareButtons(container) {
    if (container.dataset.shareButtonsInit) return;
    var toggle = container.querySelector('.share-buttons__toggle');
    var list = container.querySelector('.share-buttons__list');
    if (!toggle || !list) return;
    container.dataset.shareButtonsInit = 'true';

    function isOpen() {
      return toggle.getAttribute('aria-expanded') === 'true';
    }

    function open() {
      toggle.setAttribute('aria-expanded', 'true');
      list.removeAttribute('hidden');
    }

    function close(focusToggle) {
      toggle.setAttribute('aria-expanded', 'false');
      list.setAttribute('hidden', '');
      if (focusToggle) toggle.focus();
    }

    toggle.addEventListener('click', function () {
      if (isOpen()) close(false);
      else open();
    });

    // Escape: stop the event from reaching the parent dialog (which closes
    // on keyup) and close our list instead. Closing on keyup — not keydown —
    // ensures isOpen() is still true during the keyup bubble, so we can
    // stopPropagation before the dialog's keyup listener fires.
    function handleEscape(event) {
      if (event.key !== 'Escape' || !isOpen()) return;
      event.stopPropagation();
      if (event.type === 'keyup') close(true);
    }
    container.addEventListener('keydown', handleEscape);
    container.addEventListener('keyup', handleEscape);

    // Close when focus leaves the disclosure entirely.
    container.addEventListener('focusout', function () {
      setTimeout(function () {
        if (!container.contains(document.activeElement)) close(false);
      }, 0);
    });
  }

  function initAllShareButtons(root) {
    root.querySelectorAll('.share-buttons').forEach(initShareButtons);
  }

  initAllShareButtons(document);

  // Catch share buttons added dynamically (e.g. inside the quick-add modal).
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('.share-buttons')) initShareButtons(node);
        if (node.querySelectorAll) initAllShareButtons(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  // Click outside closes any open share list (focus is intentionally not restored).
  document.addEventListener('click', function (event) {
    document.querySelectorAll('.share-buttons').forEach(function (container) {
      var toggle = container.querySelector('.share-buttons__toggle');
      var list = container.querySelector('.share-buttons__list');
      if (!toggle || !list) return;
      if (toggle.getAttribute('aria-expanded') !== 'true') return;
      if (container.contains(event.target)) return;
      toggle.setAttribute('aria-expanded', 'false');
      list.setAttribute('hidden', '');
    });
  });

  // Product image alt text (DOM workaround for missing CMS alt values)
  if (window.location.pathname === '/products/cap-city-x-shoreline-mafia-sky-blue-camo-hoodie') {
  setTimeout(function () {
    var productAltTexts = [
      'CAP CITY HOODIE - worn front view',
      'CAP CITY HOODIE - worn front side view',
      'CAP CITY HOODIE - worn back view',
      'CAP CITY HOODIE - worn full front view',
      'CAP CITY HOODIE - front top view',
      'CAP CITY HOODIE - back top view',
      'CAP CITY HOODIE - hood logo close-up',
      'CAP CITY HOODIE - front fabric detail',
      'CAP CITY HOODIE - back fabric detail',
      'CAP CITY HOODIE - back fabric detail close-up'
    ];

    productAltTexts.forEach(function (altText, index) {
      var $sublistImg = $('.product__media-sublist .swiper-wrapper .product__media-subitem:nth-child(' + (index + 1) + ') img');
      if ($sublistImg.length && !$sublistImg.attr('alt')) {
        $sublistImg.attr('alt', altText);
      }

      var $listImg = $('.product__media-list .swiper-wrapper .product__media-item:nth-child(' + (index + 1) + ') img');
      if ($listImg.length && !$listImg.attr('alt')) {
        $listImg.attr('alt', altText);
      }

      var $listImg = $('.product-media-modal__dialog .swiper-wrapper .swiper-slide:nth-child(' + (index + 1) + ') img');
      if ($listImg.length && !$listImg.attr('alt')) {
        $listImg.attr('alt', altText);
      }
    });
  }, 1000);
  }

});
